module.exports = __webpack_public_path__ + "img/horses_letrot.9867de9b.png";